import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import {
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
  useEffect,
} from 'react'

/** Mirror the current route href into the active destination history item. */
export function useSyncActiveDestinationHref({
  locationHref,
  setOpenTabs,
  activeTabIdRef,
}: {
  locationHref: string
  setOpenTabs: Dispatch<SetStateAction<DocumentTab[]>>
  activeTabIdRef: MutableRefObject<string>
}): void {
  useEffect(() => {
    setOpenTabs((currentTabs) => {
      let changed = false
      const nextTabs = currentTabs.map((tab) => {
        if (tab.id !== activeTabIdRef.current) return tab

        const item = tab.history[tab.currentIndex]
        if (item.type !== 'destination' || item.href === locationHref) {
          return tab
        }

        const history = [...tab.history]
        history[tab.currentIndex] = { ...item, href: locationHref }
        changed = true
        return { ...tab, history }
      })
      return changed ? nextTabs : currentTabs
    })
  }, [activeTabIdRef, locationHref, setOpenTabs])
}
